// src/pages/admin/EditRolePermissionPage.js
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { doc, getDoc, setDoc } from 'firebase/firestore'
import { db } from '../../firebaseConfig'

const ALL_PERMS = [
  'dashboard',
  'users',
  'therapists',
  'therapist_services',
  'cleaners',
  'cleaner_services',
  'area_coverage',
  'finance',
  'orders',
  'reports',
  'drivers',
  'inbox',
  'settings',
  'admin_management',
]

export default function EditRolePermissionPage() {
  const { roleName } = useParams()
  const navigate = useNavigate()
  const [perms, setPerms] = useState({})
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const ref = doc(db, 'admin_roles', roleName)
        const snap = await getDoc(ref)
        if (snap.exists()) {
          setPerms(snap.data())
        } else {
          // default: all false except dashboard true
          const def = {}
          ALL_PERMS.forEach((p) => {
            def[p] = p === 'dashboard'
          })
          setPerms(def)
        }
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [roleName])

  const toggle = (k) => setPerms((p) => ({ ...p, [k]: !p[k] }))

  const save = async () => {
    setSaving(true)
    try {
      await setDoc(doc(db, 'admin_roles', roleName), perms)
      alert('Permissions saved')
      navigate('/admin-management/roles')
    } catch (err) {
      console.error(err)
      alert('Gagal menyimpan')
    } finally {
      setSaving(false)
    }
  }

  if (loading)
    return React.createElement(
      'div',
      { className: 'p-5 text-white' },
      'Loading...'
    )

  return React.createElement('div', { className: 'p-5 text-white max-w-2xl' }, [
    React.createElement(
      'h1',
      { key: 'h', className: 'text-2xl font-bold mb-4' },
      `Edit Role: ${roleName}`
    ),
    React.createElement(
      'div',
      { key: 'grid', className: 'grid grid-cols-2 gap-3 mb-4' },
      ALL_PERMS.map((p) =>
        React.createElement(
          'label',
          {
            key: p,
            className:
              'flex items-center gap-2 p-3 bg-gray-800 rounded border border-gray-700',
          },
          [
            React.createElement('input', {
              key: p + 'i',
              type: 'checkbox',
              checked: !!perms[p],
              onChange: () => toggle(p),
            }),
            React.createElement('span', { key: p + 't' }, p),
          ]
        )
      )
    ),
    React.createElement('div', { key: 'btns', className: 'flex gap-2' }, [
      React.createElement(
        'button',
        {
          key: 'save',
          onClick: save,
          disabled: saving,
          className: 'px-4 py-2 bg-blue-600 rounded',
        },
        saving ? 'Saving...' : 'Save'
      ),
      React.createElement(
        'button',
        {
          key: 'back',
          onClick: () => navigate('/admin-management/roles'),
          className: 'px-4 py-2 bg-gray-700 rounded',
        },
        'Back'
      ),
    ]),
  ])
}
